import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
// import Footer from "../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../DataTable";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import moment from "moment";

function UtilidadVentasArabel() {
  const { user } = useContext(AuthContext);
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SOCIEDADES = process.env.REACT_APP_URL_SOCIEDADES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;

  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-30);
 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");


  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");

  const [sociedades, setSociedades] = useState([]);
  const [selectedSociedad, setSelectedSociedad] = useState("");


  const [ordenesCompra, setOrdenesCompra] = useState([]);
  const [selectedOrdenesCompra, setSelectedOrdenesCompra] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [activo, setActivo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [modalDesglose, setModalDesglose] = useState(false);
  const toggleDesglose = () => setModalDesglose(!modalDesglose);
  const [rowDesglose, setRowDesglose] = useState(null);
  const [desgloseRollos, setDesgloseRollos] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const [totalTotalCosto, setTotalTotalCosto] = useState(0);
  const [totalTotalCostoActiva, setTotalTotalCostoActiva] = useState(0);
  const [totalTotalVenta, setTotalTotalVenta] = useState(0);
  const [totalTotalIVA, setTotalTotalIVA] = useState(0);
  const [totalTotalGastos, setTotalTotalGastos] = useState(0);
  const [totalTotalDevolucion, setTotalTotalDevolucion] = useState(0);
  const [totalTotalBonificacion, setTotalTotalBonificacion] = useState(0);
  const [totalTotalSaldo, setTotalTotalSaldo] = useState(0);
  const [totalTotalFlete, setTotalTotalFlete] = useState(0);
  const [totalTotalHuara, setTotalTotalHuara] = useState(0);
  const [totalTotalUtilidad, setTotalTotalUtilidad] = useState(0);
  const [totalTotalUtilidadArabel, setTotalTotalUtilidadArabel] = useState(0);

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    // if(selectedCliente){
    // axios
    //   .get(`${URL_ARTICULOS_SURTIDOS}UtilidadCliente/${selectedFechaInicio}/${selectedFechaFin}/${selectedCliente}`, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((response) => {
    //     let allSurtidos = response.data;
    //     setComments(allSurtidos);

    //     let cos = allSurtidos.map((c) => parseFloat(c.costo));
    //     let TCos = cos.reduce((t, costo, index) => t + costo, 0);
    //     setTotalTotalCosto(TCos);

    //     let ven = allSurtidos.map((c) => parseFloat(c.venta));
    //     let TVen = ven.reduce((t, venta, index) => t + venta, 0);
    //     setTotalTotalVenta(TVen);

    //     let uti = allSurtidos.map((c) => parseFloat(c.utilidad));
    //     let TUti = uti.reduce((t, utilidad, index) => t + utilidad, 0);
    //     setTotalTotalUtilidad(TUti);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // }else{
      axios
      .get(`${URL_ARTICULOS_SURTIDOS}UtilidadArabel/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allSurtidos = response.data.map((a) => ({
          ...a,
          porcentaje: a.costoActiva > 0 ? a.utilidadTotal / a.costoActiva : 0,
        }));
        setComments(allSurtidos);
      })
      .catch((err) => {
        console.log(err);
      });
    // }
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
        .get(URL_SOCIEDADES, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allSociedades = response.data;
          setSociedades(allSociedades);
        })
        .catch((err) => {
          console.log(err);
        });
        axios
        .get(`${URL_ORDENES_COMPRA}Sociedades/${selectedSociedad}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allOrdenesCompra = response.data;
          setOrdenesCompra(allOrdenesCompra);
        })
        .catch((err) => {
          console.log(err);
        });
  }, [selectedFechaInicio, selectedFechaFin, selectedSociedad]);

  const fmtMoneda = (n) =>
    new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(n || 0);
  const fmtPorcentaje = (n) =>
    new Intl.NumberFormat("en-US", {style: "percent", currency: "USD", maximumFractionDigits: 2 }).format(n || 0);
  const pctUtilidad = (utilidad, costoActiva) => (costoActiva > 0 ? utilidad / costoActiva : 0);
  const redondear = (n) => Math.round((parseFloat(n) || 0) * 100) / 100;

  // PDF, Excel y correo salen igual que el listado: mismos filtros, orden, columnas y TOTAL GENERAL
  const titulosExport = ["Fecha", "Surtido", "Sociedad", "Contenedor", "Cliente", "Costo", "Venta", "Iva", "Gastos", "Devolucion", "Bonificacion", "Flete", "Huara", "Utilidad", "Utilidad Arabel", "Saldo", "Porcentaje"];
  const camposMoneda = ["costo", "venta", "iva", "gastos", "abonosDevolucion", "abonosBonificacion", "flete", "huara", "utilidadTotal", "utilidadArabel", "saldo"];

  function totalesExport() {
    const t = {};
    [...camposMoneda, "costoActiva"].forEach((campo) => {
      t[campo] = filteredComments.reduce((s, a) => s + (parseFloat(a[campo]) || 0), 0);
    });
    return t;
  }

  function construirPDF() {
    const t = totalesExport();
    const body = filteredComments.map((a) => [
      a.fecha,
      a.numeroSurtido,
      a.sociedad,
      a.ordenesCompra,
      a.cliente,
      ...camposMoneda.map((campo) => fmtMoneda(a[campo])),
      fmtPorcentaje(pctUtilidad(a.utilidadTotal, a.costoActiva)),
    ]);
    const foot = [
      "", "", "", "", "TOTAL GENERAL",
      ...camposMoneda.map((campo) => fmtMoneda(t[campo])),
      fmtPorcentaje(pctUtilidad(t.utilidadTotal, t.costoActiva)),
    ];
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 245, 10, 33, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 245, 23, 35, 25);
    doc.text(`Utilidad Ventas Arabel`, 15, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 15, 40);
    doc.autoTable({
      head: [titulosExport],
      body: body,
      foot: [foot],
      startY: 50,
      margin: { left: 8, right: 8 },
      styles: { fontSize: 6.5, cellPadding: 1 },
      showFoot: "lastPage",
      didParseCell: (data) => {
        const fila = filteredComments[data.row.index];
        if (data.section === "body" && data.column.index === 5 && fila && fila.bonifCompra > 0) {
          data.cell.styles.fillColor = [251, 239, 213];
        }
      },
    });
    if (filteredComments.some((a) => a.bonifCompra > 0)) {
      doc.setFontSize(7);
      doc.text("Costo sombreado: incluye bonificación de la compra prorrateada.", 8, doc.lastAutoTable.finalY + 6);
    }
    return doc;
  }

  function PDFTabla() {
    construirPDF().save(`Utilidad.pdf`);
  }

  function excel() {
    const t = totalesExport();
    const fila = (a, pct) => {
      const o = {
        Fecha: a.fecha,
        Surtido: a.numeroSurtido,
        Sociedad: a.sociedad,
        Contenedor: a.ordenesCompra,
        Cliente: a.cliente,
      };
      camposMoneda.forEach((campo, i) => {
        o[titulosExport[5 + i]] = redondear(a[campo]);
      });
      o.Porcentaje = redondear(pct * 100);
      return o;
    };
    const dataExcel = filteredComments.map((a) => fila(a, pctUtilidad(a.utilidadTotal, a.costoActiva)));
    dataExcel.push(
      fila({ ...t, fecha: "", numeroSurtido: "", sociedad: "", ordenesCompra: "", cliente: "TOTAL GENERAL" },
        pctUtilidad(t.utilidadTotal, t.costoActiva))
    );

    var option = {};
    option.fileName = "Utilidad";
    option.datas = [
      {
        sheetData: dataExcel,
        sheetName: "Utilidad",
        sheetFilter: titulosExport,
        sheetHeader: titulosExport,
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const doc = construirPDF();
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Utilidad Ventas Arabel",
          email: mailTo,
          fileName: "Utilidad.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras la Utilidad de las Ventas Arabel.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Enviado con Exito!",
          showConfirmButton: false,
          timer: 2000,
        });
        setMailTo("");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Surtido", field: "numeroSurtido", sortable: true },
    { name: "Sociedad", field: "sociedad", sortable: true },
    { name: "Contenedor", field: "ordenesCompra", sortable: true },
    { name: "Cliente", field: "cliente", sortable: true },
    { name: "Costo", field: "costo", sortable: true },
    { name: "Venta", field: "venta", sortable: true },
    { name: "Iva", field: "iva", sortable: true },
    { name: "Gastos", field: "gastos", sortable: true },
    { name: "Devolucion", field: "abonosDevolucion", sortable: true },
    { name: "Bonificacion", field: "abonosBonificacion", sortable: true },
    { name: "Flete", field: "flete", sortable: true },
    { name: "Huara", field: "huara", sortable: true },
    { name: "Utilidad", field: "utilidadTotal", sortable: true },
    { name: "Utilidad Arabel", field: "utilidadArabel", sortable: true },
    // { name: "Utilidad Arabel", field: "utilidadArabel", sortable: false },
    { name: "Saldo", field: "saldo", sortable: true },
    { name: "Porcentaje", field: "porcentaje", sortable: true },
    { name: "Detalle", field: "detalle", sortable: false },
  ];

  const filteredComments = useMemo(() => {
    let computedComments = [...comments];

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.cliente.toLowerCase().includes(search.toLowerCase()) ||
          comment.sociedad.toLowerCase().includes(search.toLowerCase()) ||
          comment.ordenesCompra.toLowerCase().includes(search.toLowerCase()) ||
          comment.numeroSurtido.toString().includes(search) ||
          comment.costo.toString().includes(search) ||
          comment.venta.toString().includes(search) ||
          comment.iva.toString().includes(search) ||
          comment.gastos.toString().includes(search) ||
          comment.abonosDevolucion.toString().includes(search) ||
          comment.abonosBonificacion.toString().includes(search) ||
          comment.saldo.toString().includes(search) ||
          comment.flete.toString().includes(search) ||
          comment.huara.toString().includes(search) ||
          comment.utilidadTotal.toString().includes(search)
          ||
          comment.utilidadArabel.toString().includes(search)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idCliente.includes(selectedCliente)
      );
    }

    if (selectedSociedad) {
      computedComments = computedComments.filter((e) =>
        e.idSociedad.includes(selectedSociedad)
      );
    }
    if (selectedOrdenesCompra) {
      computedComments = computedComments.filter((e) =>
        e.idOrdenesCompra.includes(selectedOrdenesCompra)
      );
    }

    let cos = computedComments.map((c) => parseFloat(c.costo));
    let TCos = cos.reduce((t, costo, index) => t + costo, 0);
    setTotalTotalCosto(TCos);

    let cosA = computedComments.map((c) => parseFloat(c.costoActiva || 0));
    let TCosA = cosA.reduce((t, costo, index) => t + costo, 0);
    setTotalTotalCostoActiva(TCosA);

    let ven = computedComments.map((c) => parseFloat(c.venta));
    let TVen = ven.reduce((t, venta, index) => t + venta, 0);
    setTotalTotalVenta(TVen);

    let iv = computedComments.map((c) => parseFloat(c.iva));
    let TIv = iv.reduce((t, iva, index) => t + iva, 0);
    setTotalTotalIVA(TIv);

    let gas = computedComments.map((c) => parseFloat(c.gastos));
    let TGas = gas.reduce((t, gastos, index) => t + gastos, 0);
    setTotalTotalGastos(TGas);

    let dev = computedComments.map((c) => parseFloat(c.abonosDevolucion));
    let TDev = dev.reduce((t, devolucion, index) => t + devolucion, 0);
    setTotalTotalDevolucion(TDev);

    let bon = computedComments.map((c) => parseFloat(c.abonosBonificacion));
    let TBon = bon.reduce((t, bonificacion, index) => t + bonificacion, 0);
    setTotalTotalBonificacion(TBon);

    let sal = computedComments.map((c) => parseFloat(c.saldo));
    let TSal = sal.reduce((t, saldo, index) => t + saldo, 0);
    setTotalTotalSaldo(TSal);

    let fle = computedComments.map((c) => parseFloat(c.flete));
    let TFle = fle.reduce((t, flete, index) => t + flete, 0);
    setTotalTotalFlete(TFle);

    let hua = computedComments.map((c) => parseFloat(c.huara));
    let THua = hua.reduce((t, huara, index) => t + huara, 0);
    setTotalTotalHuara(THua);

    let uti = computedComments.map((c) => parseFloat(c.utilidadTotal));
    let TUti = uti.reduce((t, utilidad, index) => t + utilidad, 0);
    setTotalTotalUtilidad(TUti);

    let utiAra = computedComments.map((c) => parseFloat(c.utilidadArabel));
    let TUtiAra = utiAra.reduce((t, utilidad, index) => t + utilidad, 0);
    setTotalTotalUtilidadArabel(TUtiAra);


    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "numeroSurtido" &&
      sorting.field != "costo" &&
      sorting.field != "venta" &&
      sorting.field != "iva" &&
      sorting.field != "gastos" &&
      sorting.field != "abonosDevolucion" &&
      sorting.field != "abonosBonificacion" &&
      sorting.field != "saldo" &&
      sorting.field != "flete" &&
      sorting.field != "huara" &&
      sorting.field != "utilidad" &&
      sorting.field != "utilidadTotal" &&
      sorting.field != "utilidadArabel" &&
      sorting.field != "porcentaje"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "numeroSurtido" ||
        sorting.field == "costo" ||
        sorting.field == "venta" ||
        sorting.field == "iva" ||
        sorting.field == "gastos" ||
        sorting.field == "abonosDevolucion" ||
        sorting.field == "abonosBonificacion" ||
        sorting.field == "saldo" ||
        sorting.field == "flete" ||
        sorting.field == "huara" ||
        sorting.field == "utilidad" ||
        sorting.field == "utilidadTotal" ||
        sorting.field == "utilidadArabel" ||
        sorting.field == "porcentaje")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "numeroSurtido" ||
        sorting.field == "costo" ||
        sorting.field == "venta" ||
        sorting.field == "iva" ||
        sorting.field == "gastos" ||
        sorting.field == "abonosDevolucion" ||
        sorting.field == "abonosBonificacion" ||
        sorting.field == "saldo" ||
        sorting.field == "flete" ||
        sorting.field == "huara" ||
        sorting.field == "utilidad" ||
        sorting.field == "utilidadTotal" ||
        sorting.field == "utilidadArabel" ||
        sorting.field == "porcentaje")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    return computedComments;
  }, [
    comments,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    selectedCliente,
    selectedSociedad,
    selectedOrdenesCompra,
  ]);

  const commentsData = useMemo(
    () =>
      filteredComments.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
      ),
    [filteredComments, currentPage]
  );

  let totalCostoTabla = 0;
  let totalVentaTabla = 0;
  let totalIvaTabla = 0;
  let totalGastosTabla = 0;
  let totalDevolucionTabla = 0;
  let totalBonificacionTabla = 0;
  let totalSaldoTabla = 0;
  let totalFleteTabla = 0;
  let totalHuaraTabla = 0;
  let totalUtilidadTabla = 0;
  let totalUtilidadArabelTabla = 0;

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_admin ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuAdmin"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Utilidad</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Reporte Utilidad Arabel</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col><Col md={2}>
              <Label>Sociedades</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedSociedad}
                onChange={(e) => {
                  setSelectedSociedad(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {sociedades
                  .sort((a, b) =>
                    a.nombre > b.nombre ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre}</option>;
                  })}
              </Input>
            </Col>
            <Col md={2}>
              <Label>Contenedor</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedOrdenesCompra}
                onChange={(e) => {
                  setSelectedOrdenesCompra(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {ordenesCompra
                .filter((a) => a.is_active === "Si")
                  .sort((a, b) =>
                    a.observaciones > b.observaciones ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.observaciones}</option>;
                  })}
              </Input>
            </Col>
            <Col md={2}>
              <Label>Clientes</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
            
          </Row>
          <br />
          <small>
            <span style={{ backgroundColor: "#fbefd5", padding: "0 10px", marginRight: 6 }}></span>
            Costo con bonificación de la compra prorrateada (pasa el mouse para ver el monto)
          </small>
          <div className="table-wrapper">
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                totalCostoTabla = totalCostoTabla + a.costo;
                totalVentaTabla = totalVentaTabla + a.venta;
                totalIvaTabla = totalIvaTabla + a.iva;
                totalGastosTabla = totalGastosTabla + a.gastos;
                totalDevolucionTabla = totalDevolucionTabla + a.abonosDevolucion;
                totalBonificacionTabla = totalBonificacionTabla + a.abonosBonificacion;
                totalSaldoTabla = totalSaldoTabla + a.saldo;
                totalFleteTabla = totalFleteTabla + a.flete;
                totalHuaraTabla = totalHuaraTabla + a.huara;
                totalUtilidadTabla = totalUtilidadTabla + a.utilidadTotal;
                totalUtilidadArabelTabla = totalUtilidadArabelTabla + a.utilidadArabel;
                  return (
                    <tr style={a.saldo == 0 ? { backgroundColor: "#64e379" }: {  }}>
                      <td>{a.fecha}</td>
                      <td>{a.numeroSurtido}</td>
                      <td>{a.sociedad}</td>
                      <td>{a.ordenesCompra}</td>
                      <td>{a.cliente}</td>
                      <td
                        style={a.bonifCompra > 0 ? { backgroundColor: "#fbefd5" } : {}}
                        title={
                          a.bonifCompra > 0
                            ? `Bonificación de compra prorrateada: ${new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.bonifCompra)} (sin bonificación: ${new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.costo + a.bonifCompra)})`
                            : ""
                        }
                      >
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.costo)}
                      </td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.venta)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.iva)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.gastos)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.abonosDevolucion)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.abonosBonificacion)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.flete)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.huara)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.utilidadTotal)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.utilidadArabel)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.saldo)}</td>
                      <td>{new Intl.NumberFormat("en-US", {style: "percent", currency: "USD", maximumFractionDigits: 2 }).format(a.costoActiva > 0 ? a.utilidadTotal / a.costoActiva : 0)}</td>
                      <td>
                        <Button
                          size="sm"
                          color="info"
                          onClick={() => {
                            setRowDesglose(a);
                            setDesgloseRollos([]);
                            axios
                              .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${a.idSurtido}`, {
                                headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
                              })
                              .then((res) => setDesgloseRollos(res.data))
                              .catch((err) => console.log(err));
                            setModalDesglose(true);
                          }}
                          title="Desglose de utilidad"
                        >
                          <i class="fas fa-search-dollar"></i>
                        </Button>
                      </td>
                    </tr>
                  );
              })}
              {/* <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  TOTAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalCostoTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalVentaTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalIvaTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalGastosTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalFleteTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalHuaraTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalUtilidadTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalUtilidadArabelTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalSaldoTabla)}
                </td>
                <td className="negrita">{new Intl.NumberFormat("en-US", {style: "percent", currency: "USD", maximumFractionDigits: 2 }).format(totalUtilidadTabla / totalCostoTabla)}</td>
              </tr> */}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  TOTAL GENERAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalTotalCosto)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalTotalVenta)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalTotalIVA)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalTotalGastos)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalTotalDevolucion)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalTotalBonificacion)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalTotalFlete)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalTotalHuara)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalTotalUtilidad)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalTotalUtilidadArabel)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(totalTotalSaldo)}
                </td>
                <td className="negrita">{new Intl.NumberFormat("en-US", {style: "percent", currency: "USD", maximumFractionDigits: 2 }).format(totalTotalCostoActiva > 0 ? totalTotalUtilidad / totalTotalCostoActiva : 0)}</td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          </div>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="lg" isOpen={modalDesglose} toggle={toggleDesglose}>
        <ModalHeader toggle={toggleDesglose}>
          Desglose de Utilidad {rowDesglose ? `— Surtido #${rowDesglose.numeroSurtido}` : ""}
        </ModalHeader>
        <ModalBody>
          {rowDesglose ? (() => {
            const fmt = (n) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(n || 0);
            const ventaAct = rowDesglose.ventaActiva || 0;
            const costoAct = rowDesglose.costoActiva || 0;
            const margenAct = ventaAct - costoAct;
            const pct = costoAct > 0 ? (rowDesglose.utilidadTotal / costoAct) * 100 : 0;
            return (
              <>
                <p>
                  <b>Cliente:</b> {rowDesglose.cliente} &nbsp;&nbsp; <b>Sociedad:</b> {rowDesglose.sociedad}
                </p>

                <h6 style={{ fontWeight: "bold" }}>Detalle de rollos ({desgloseRollos.length}) — la utilidad cuenta solo los ACTIVOS</h6>
                <div style={{ maxHeight: 240, overflowY: "auto" }}>
                  <Table size="sm" striped bordered>
                    <thead>
                      <tr>
                        <th>Articulo</th><th>Color</th><th>Clave</th><th>Activo</th>
                        <th align="right">Cant.</th><th align="right">Costo U.</th><th align="right">Costo</th>
                        <th align="right">Precio</th><th align="right">Venta</th>
                      </tr>
                    </thead>
                    <tbody>
                      {desgloseRollos.map((r) => {
                        const inv = r.inventarios && r.inventarios[0] ? r.inventarios[0] : {};
                        const cant = parseFloat(inv.cantidad || 0);
                        const costoU = parseFloat(inv.costo || 0);
                        const precio = parseFloat(r.precio || 0);
                        const activo = r.is_active === "Si";
                        return (
                          <tr key={r._id} style={activo ? {} : { color: "#b00", textDecoration: "line-through" }}>
                            <td>{inv.articulos && inv.articulos[0] ? `${inv.articulos[0].codigo} ${inv.articulos[0].nombre}` : ""}</td>
                            <td>{inv.colores && inv.colores[0] ? inv.colores[0].name : ""}</td>
                            <td>{inv.clave}</td>
                            <td>{activo ? "Sí" : "No"}</td>
                            <td align="right">{cant}</td>
                            <td align="right">{fmt(costoU)}</td>
                            <td align="right">{fmt(costoU * cant)}</td>
                            <td align="right">{fmt(precio)}</td>
                            <td align="right">{fmt(precio * cant)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr style={{ fontWeight: "bold" }}>
                        <td colSpan={6} align="right">Activos (para utilidad)</td>
                        <td align="right">{fmt(costoAct)}</td>
                        <td></td>
                        <td align="right">{fmt(ventaAct)}</td>
                      </tr>
                    </tfoot>
                  </Table>
                </div>

                <h6 style={{ fontWeight: "bold", marginTop: 10 }}>Resumen de utilidad (solo rollos activos)</h6>
                <Table size="sm" borderless>
                  <tbody>
                    <tr><td>Venta activa</td><td align="right">{fmt(ventaAct)}</td></tr>
                    <tr><td>(−) Costo activo</td><td align="right">−{fmt(costoAct)}</td></tr>
                    <tr style={{ borderTop: "1px solid #ccc", fontWeight: "bold" }}><td>= Margen</td><td align="right">{fmt(margenAct)}</td></tr>
                    <tr><td>(+) Huara</td><td align="right">{fmt(rowDesglose.huara)}</td></tr>
                    <tr><td>(−) Gastos</td><td align="right">−{fmt(rowDesglose.gastos)}</td></tr>
                    <tr><td>(−) Flete</td><td align="right">−{fmt(rowDesglose.flete)}</td></tr>
                    <tr><td>(−) Bonificación</td><td align="right">−{fmt(rowDesglose.abonosBonificacion)}</td></tr>
                    <tr style={{ borderTop: "2px solid #333", fontWeight: "bold", fontSize: "1.1em" }}><td>= Utilidad</td><td align="right">{fmt(rowDesglose.utilidadTotal)}</td></tr>
                    <tr><td>Utilidad Arabel</td><td align="right">{fmt(rowDesglose.utilidadArabel)}</td></tr>
                    <tr><td>Porcentaje</td><td align="right">{pct.toFixed(2)}%</td></tr>
                  </tbody>
                </Table>
                <small>
                  Venta bruta {fmt(rowDesglose.ventaBruta)} · Devolución {fmt(rowDesglose.abonosDevolucion)}. Utilidad = (Venta activa − Costo activo) + Huara − Gastos − Flete − Bonificación. Los rollos devueltos/movidos (tachados) no cuentan.
                  {rowDesglose.bonifCompra > 0 ? (
                    <>
                      <br />
                      <span style={{ backgroundColor: "#fbefd5" }}>
                        El costo activo ya trae descontada la bonificación de la compra prorrateada: {fmt(rowDesglose.bonifCompra)} (los rollos de arriba muestran su costo original).
                      </span>
                    </>
                  ) : null}
                </small>
              </>
            );
          })() : null}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" size="sm" onClick={toggleDesglose}>Cerrar</Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default UtilidadVentasArabel;
